import React from 'react';
import './BackendStatusBanner.css';

interface BackendStatusBannerProps {
  isVisible: boolean;
}

const BackendStatusBanner: React.FC<BackendStatusBannerProps> = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="backend-status-banner">
      <div className="backend-status-banner-content">
        <span className="backend-status-banner-icon">⚠️</span>
        <span className="backend-status-banner-text">
          Backend wird gewartet, bitte versuche es später noch einmal
        </span>
      </div>
    </div>
  );
};

export default BackendStatusBanner;





